const sidebarNav = [
	{
		link: '/dashboard',
		section: 'dashboard',
		icon: 'bx bx-home-alt',
		text: 'DASHBOARD',
	},
	{
		link: '/user-list',
		section: 'user-list',
		icon: 'bx bx-user',
		text: 'USERS LIST',
	},
	{
		link: '/group-list',
		section: 'group-list',
		icon: 'bx bx-receipt',
		text: 'GROUPS LIST',
	},
	{
		link: '/devices-list',
		section: 'devices-list',
		icon: 'bx bx-cube',
		text: 'DEVICES LIST ',
	},

	// {
	// 	link: '/settings',
	// 	section: 'settings',
	// 	icon: <i className="bx bx-cog"></i>,
	// 	text: 'Settings',
	// },
];

export default sidebarNav;
